import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import VueClickAway from "vue3-click-away";
import VueGtag from "vue-gtag";

import App from "@mod/main/web_booking_agent/App.vue";

import "@mod/css/style2.css";

if(import.meta.env.VITE_DEFAULT_CLASS == 'RTG') { 
    import("@mod/css/styleRTG.css");
}
if(import.meta.env.VITE_DEFAULT_CLASS == 'AAT') { 
    import("@mod/css/styleAAT.css");
}
if(import.meta.env.VITE_DEFAULT_CLASS == 'SEIT') { 
    import("@mod/css/styleSEIT.css");
}

import router from "@mod/main/web_booking_agent/routes";
import store from "@mod/tms/booking_engine/store/index";

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

createApp(App)
    .use(store)
    .use(pinia)
    .use(VueGtag, {
        config: { id: import.meta.env.VITE_GA_ID },
        appName: import.meta.env.VITE_GA_APP_NAME,
        pageTrackerScreenviewEnabled: true
    }, router)
    .use(router)
    .use(VueClickAway)
    .mount('#app');